import { PathEntry, PathGenerator } from "./Game World/Game Map/PathGenerator";



export class Checkpoint {
    /**
     * (RO) Skore hrace pri dosazeni checkpointu
     */
    get score(): number { return this._score; }
    private _score: number;

    /**
     * (RO) Zaznam trasy, pro kterou je checkpoint urcen 
     */
    get pathEntry(): PathEntry { return PathGenerator.INSTANCE.getPathEntry(this._pathEntryId); }

    /**
     * (RO) Index zaznamu trasy, pro kterou je checkpoint urcen
     */
    get pathEntryId(): number { return this._pathEntryId; }
    private _pathEntryId: number;

    /**
     * (RO) True, pokud je checkpoint platny
     */
    get valid(): boolean { return this._pathEntryId >= 0; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._pathEntryId = -1;
    }

    //-------------------------------------------------------------------------
    /**
     * Nastaveni checkpointu
     * @param score Skore hrace pri dosazeni checkpointu
     * @param pathEntryId Index zaznamu trasy, pro kterou je checkpoint urcen
     */
    //-------------------------------------------------------------------------
    set(score: number, pathEntryId: number): void {
        this._score = score;
        this._pathEntryId = pathEntryId;
    }
}